// Products & Services — top-level screen (documents parity sweep Wave B, #22: owner-flagged
// "why was products and services not added? that is part of documents"). Previously this UI only
// existed buried inside Settings → Stock (see settings.js's git history); this thin screen gives
// it its own nav item + route (`/co/{id}/products`, tshell.js's `products` TNAV entry) while
// REUSING buildStockTab(companyId) wholesale — no reimplementation of the inventory UI.
import { html } from '../shared/t4.js';
import { t } from '../shared/i18n.js';
import { tenantShell } from './tshell.js';
import { buildStockTab } from './inventory.js';

export function productsScreen(companyId){
  const stock = buildStockTab(companyId);
  stock.onShow();
  return tenantShell(companyId, t('nav.service_items_v2', 'Service items'), html`<div class="page page-wide products-page ux-list-page">
    <h1 class="sr-only">${() => t('nav.service_items_v2', 'Service items')}</h1>
    ${stock.node}
  </div>`);
}
